import React from 'react'
import { LDProvider } from 'launchdarkly-react-client-sdk'
import { getLaunchDarklyClient, LDConfig } from '../../../config/launchDarkly'
import { Outlet } from 'react-router-dom'

export default function PublicRoute() {
	return (
		<LDProvider
			clientSideID={LDConfig.clientSideID}
			reactOptions={LDConfig.reactOptions}
			ldClient={getLaunchDarklyClient()}
			context={{ ...LDConfig.context }}
		>
			<Outlet />
		</LDProvider>
	)
}
